<template>
  <div
    class="tw:h-full tw:max-h-[50vh] tw:overflow-hidden tw:overflow-y-auto tw:rounded-md tw:bg-white tw:drop-shadow-md"
  >
    <table
      class="tw:w-full tw:border-collapse tw:text-center tw:text-sm tw:text-denim-900"
    >
      <thead class="tw:sticky tw:top-0 tw:z-10">
        <tr class="tw:bg-denim-100 tw:font-bold">
          <slot name="header" />
        </tr>
      </thead>
      <tbody v-if="hasSyndications">
        <tr
          v-for="(syndicated, index) in sortedSyndications"
          :key="index"
          class="syndications__faux-border tw:relative"
          data-testid="syndications-table-row"
          @click.stop="$emit('syndication-clicked', syndicated)"
        >
          <slot
            name="body"
            :syndicated="syndicated"
          />
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts" generic="S extends Syndication">
import { computed } from "vue";

import type { Syndication } from "shared/types/mentions";

const props = defineProps<{
  syndications: S[];
  sortBy: keyof S;
}>();

defineEmits<{
  (e: "syndication-clicked", syndication: S): void;
}>();

const hasSyndications = computed(
  () => (props.syndications && props.syndications.length) ?? false
);

const sortedSyndications = computed<S[]>(() => {
  if (!hasSyndications.value) return [];

  return props
    .syndications!.slice()
    .sort((syndicationA: S, syndicationB: S) =>
      (syndicationA[props.sortBy] ?? "") > (syndicationB[props.sortBy] ?? "")
        ? 1
        : -1
    );
});
</script>

<style lang="scss" scoped>
.syndications__faux-border:not(:last-child)::after {
  background: var(--s-color-denim-3);
  bottom: 0;
  content: "";
  display: block;
  height: 1px;
  left: 1rem;
  position: absolute;
  width: calc(100% - 2rem);
}
</style>
